<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jzyWcr/images/WINDofPROMISE-cover.jpg?1732137037105" alt="This image is the cover for the book Wind of Promise, Wind Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wind of Promise, Wind Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Vanessa is determined to cross the prairies, ford the mighty rivers and climb the Rockies to reach Colorado. But her resolve weakens when a tall, lean stranger as wild as the western wind takes her in his arms. Will surrender to this restless roamer bring her happiness - or will it break her heart forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Garlock
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Warner Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15fd5981